import { type ClusterWithCloudConnect } from "@doitintl/cmp-models";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Checkbox, Tooltip, Typography, useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";

interface ClusterBulkSelectorItemProps {
  cluster: ClusterWithCloudConnect;
  allowPrivateClusters?: boolean;
  selected?: boolean;
  onSelect?: (cluster: ClusterWithCloudConnect) => void;
}

const ClusterBulkSelectorItem = ({
  cluster,
  allowPrivateClusters,
  selected,
  onSelect,
}: ClusterBulkSelectorItemProps) => {
  const theme = useTheme();

  const handleSelect = () => {
    if (!allowPrivateClusters && cluster.isPrivate) return;
    onSelect?.(cluster);
  };

  return (
    <Box
      key={cluster.id}
      sx={{
        display: "flex",
        alignItems: "center",
        opacity: cluster.isPrivate ? 0.5 : 1,
        cursor: cluster.isPrivate ? "not-allowed" : "pointer",
      }}
    >
      <Checkbox onChange={handleSelect} checked={selected} disabled={cluster.isPrivate} />
      <Stack direction="row" spacing={1}>
        <Typography variant="body1" onClick={handleSelect}>
          {cluster.name} ({cluster.region})
        </Typography>
        {!allowPrivateClusters && cluster.isPrivate && (
          <Tooltip
            title="This cluster is private. Kubernetes features can't be enabled on private clusters."
            placement="right"
          >
            <Box display="flex" alignItems="center">
              <InfoOutlinedIcon sx={{ fontSize: "16px", color: theme.palette.text.disabled }} />
            </Box>
          </Tooltip>
        )}
      </Stack>
    </Box>
  );
};
export default ClusterBulkSelectorItem;
